import { Injectable } from '@angular/core';
import {
  AddSqaContent,
  RequestAddSqa,
  SecurityQuestionContentApi
} from '@com-delta-idp/mnx-login-ui';
import { LoginModalContent } from '../../models/aem';
import { AddSqaHelperService } from '../../services/add-sqa/add-sqa-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AddSqaAdaptersService {
  constructor(private helper: AddSqaHelperService) {}

  getAddSqaContent(
    loginAemResponse: LoginModalContent,
    securityQuestions: SecurityQuestionContentApi
  ): AddSqaContent {
    return {
      formGroup: this.helper.createForm(),
      formAttributes: this.helper.getFormAttributes(),
      pageContent: this.helper.getPageContent(
        loginAemResponse,
        securityQuestions
      ),
      hasError: false,
      errorMessage: ''
    };
  }

  setAddSqaRequestObj(content: AddSqaContent): RequestAddSqa {
    const formValues = content.formGroup.getRawValue();
    return {
      securityQuestionNbr1: formValues.questionOne.value,
      securityQuestionNbr2: formValues.questionTwo.value,
      tlMaskInfo_answer1: formValues.answerOne.value,
      tlMaskInfo_answer2: formValues.answerTwo.value
    };
  }
}
